module.exports = __webpack_public_path__ + "img/jiaoxue_heroes_score_grade.fc2474ce.png";